import { createSelector } from 'reselect'

import { getSelectedScene } from 'models/compositions/selectors'

export const getIsFetching = (state) => state.ratings.isFetching
export const getRatingsByJobId = (state) => state.ratings.ratingsByJobId
export const getRatingOptions = (state) => state.ratings.options

export const getRatingForSelectedScene = createSelector(
    [getRatingsByJobId, getSelectedScene],
    (ratingsByJobId, selectedScene) => {
        if (!selectedScene) {
            return {}
        }
        return ratingsByJobId[selectedScene.jobId] || {}
    },
)
